import React, { useEffect, useState } from 'react';
import { emailsMagasins, Magasin } from "../../../../../Models/Magasin/MagasinModels";
import { Email, TypeEmail } from '../../../../../Models/Email/EmailModels';
import { EmailService } from '../../../../../Services/Email/EmailService';
import { useCookies } from 'react-cookie';
import { SelectChangeEvent, Dialog, DialogTitle, DialogContent, FormControl, InputLabel, Select, Input, TextField, DialogActions, Button, MenuItem } from '@mui/material';
import { URL_MIDIS } from '../../../../../Setting';
import DialogForm from '../../../../Commun/DialogForm';

export interface AddEditAdresseDialogProps {
    open: boolean,
    state:string,
    editedEmailDialog?:Email,
    editedEmailMagasin?:emailsMagasins,
    onClose: () => void,
    emailsMagasins : emailsMagasins[],
    typeEmail:TypeEmail,
    handleAddEdit:()=>void,
    setSnackbarState:any
}

export function DialogAddEditAdresse(props : AddEditAdresseDialogProps){

    const { open, state, editedEmailDialog, editedEmailMagasin, onClose, emailsMagasins, typeEmail, handleAddEdit, setSnackbarState} = props;
    const [title, setTitle]=useState('');
    const [actionTitle, setActionTitle]=useState('');
    const [cookies] = useCookies(['token']);
    const token = cookies.token;
    const [idMagasin, setIDMagasin] = useState(0);
    const [adresseEmail, setAdresseEmail] = useState('');
    const handleChangeMagasin = (event: SelectChangeEvent<any>)=>{
        setIDMagasin(event.target.value)
    }

    const affichageImgMagasin = (mag:Magasin)=>{
        const selectedTypeMagasin = mag?.typeMagasin;
        if(selectedTypeMagasin){
            const fichiersTypeMag = selectedTypeMagasin.fichiers;
            if(fichiersTypeMag && fichiersTypeMag.length>0){
            const url = `${URL_MIDIS+fichiersTypeMag[0].chemin}`;
            return (<div style={{display:'flex'}}><img src={url} alt="" style={{width:50, marginRight:'8px'}}/>{mag.nom.toUpperCase()}</div>)
            }
        }
        return 'Aucun'
    }

    useEffect(()=>{
        if(state==='Add'){
            setTitle("Ajout d'une nouvelle adresse de contact")
            setActionTitle('Ajouter');
        }else{
            if(editedEmailMagasin && editedEmailDialog){
                setIDMagasin(editedEmailMagasin?.magasin.id);
                setAdresseEmail(editedEmailDialog.email)
                setTitle("Modifier une adresse de contact")
                setActionTitle('Modifier');
            }
        }
    },[editedEmailDialog, editedEmailMagasin, state]);

    return (
        <DialogForm
            open={open}
            onClose={onClose}
            onSubmit={async (event: React.FormEvent<HTMLFormElement>) => {
                setSnackbarState(state);
                const service = EmailService();
                event.preventDefault();
                const formData = new FormData(event.currentTarget);   // <-- plus de cast
                const formJson = Object.fromEntries((formData as any).entries());
                if(state==='Add'){
                    const statusAdd = await service.postNewAdresseContact(token, formJson['MagasinSelect'], formJson['email'], typeEmail)
                    if(statusAdd.status===201||statusAdd.status===200){
                        handleAddEdit();
                    }
                }else if(state==='Edit'){
                    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if(regexEmail.test(formJson['email'])){
                        const statusEdit = await service.patchAdresseContact(formJson['email'], editedEmailDialog?.id, formJson['MagasinSelect'], typeEmail, token);
                        if(statusEdit===201||statusEdit===200){
                            handleAddEdit()
                        }
                    }
                }
                onClose();
            }}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent sx={{
                display:'flex',
                flexDirection:'column',
            }}
            >
                {
                    <>
                        <FormControl variant="standard" sx={{m:1}}>
                            <InputLabel htmlFor="select-magasin">Magasin</InputLabel>
                                <Select
                                    error={idMagasin===0}
                                    name='MagasinSelect'
                                    value={idMagasin}
                                    onChange={handleChangeMagasin}
                                >
                                    <MenuItem value={0}>
                                        <em>Aucun</em>
                                    </MenuItem>
                                    {
                                        emailsMagasins.map((emailMag)=>(
                                            <MenuItem key={emailMag.idMagasin} value={emailMag.idMagasin}>{affichageImgMagasin(emailMag.magasin)}</MenuItem>
                                        ))
                                    }
                                </Select>
                        </FormControl>
                        <FormControl variant="standard" sx={{m:1}}>
                            <InputLabel htmlFor="input-adresse-contact">
                                Adresse de contact
                            </InputLabel>
                            <Input
                                error={adresseEmail.length===0 || !adresseEmail || /^\s*$/.test(adresseEmail)}
                                autoFocus
                                required
                                value={adresseEmail}
                                margin="dense"
                                id="adresseEmail"
                                name="email"
                                type="email"
                                onChange={(event)=>{setAdresseEmail(event.target.value)}}
                                fullWidth
                            />
                        </FormControl>
                        <FormControl variant="standard" sx={{m:1}}>
                            <TextField
                                id="outlined-read-only-input"
                                label="Type d'adresse de contact"
                                defaultValue={typeEmail.type}
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    },
                                }}
                            />
                        </FormControl>
                    </>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuler</Button>
                <Button type="submit">{actionTitle}</Button>
            </DialogActions>
        </DialogForm>
    );

}
